// removed by extract-text-webpack-plugin
module.exports = {"label":"_17UoRrwjauOhjimCHd7AjP","component":"_3jIw447LCuEWwnAQjtj7Ud","input":"_3fXJV1OLLk20WdMS6b6372","labelText":"OeWRDpq6gEOd6Tei2CcEk","clippy":"_3u_pxJjgjWA80GTGoEwira"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AttachmentButton/AttachmentButton.css
// module id = 1368
// module chunks = 0